export class DatetimeRangePickerInputModel {
  dateFrom?: Date;
  dateTo?: Date;
  period?: number;
}
